import api from '../../api/'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id: "",
            entite_nom: "",
            nom_agence: "",
            ville: "",
            commune: "",
            telephone: "",        
            description: "",
            active: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {           
            row = {
                id: element.id,
                entite_nom: element.entite_nom.toUpperCase(),
                nom_agence: element.nom_agence === null ? null : element.nom_agence.toUpperCase(),
                ville: element.ville === null ? null : element.ville.toUpperCase(),
                commune:element.commune === null ? null : element.commune.toUpperCase(),
                telephone: element.telephone,      
                email: element.email,
                active: element.active === 1 ? 'activée' : 'désactivée',
                description: element.description,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at,
                //btn: "<router-link to='/theme/agences/show/"+element.id+"'><button class='btn btn-pill btn-success'><i class='fa fa-plus'></i></button></router-link><button class='btn btn-pill btn-info'><i class='fa fa-pencil'></i></button><button class='btn btn-pill btn-danger'><i class='fa fa-trash'></i></button>"
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setAgency(state, agences) {
        state.all = agences
    },
    addAgency(state, agency){
        state.all.push(agency)
    }
}

const actions={
    get_all_agencies({ commit }){
        return api.agency.get_all_agencies().then(response =>{                  
            commit('setAgency', response.data.data.data)
            return response.data.data
        })
    },
    get_all_agencies_by_entity({ commit }, serverParams){
        return api.agency.get_all_agencies_by_entity(serverParams).then(response =>{                  
            commit('setAgency', response.data.data.data)
            return response.data.data.data
        })
    },
    get_all_agenciesOwn({ commit }, serverParams){
        return api.agency.get_all_agenciesOwn(serverParams).then(response =>{       
            console.log(response.data.data)
            commit('setAgency', response.data.data.data)
            return response.data.data
        })
    },
    agence_active({ commit }) {
        return api.agency.agence_active().then((response) => {
            console.log("mes agences actives : ",response.data)
            commit('setAgency', response.data.data)
            return response.data
        })
    },
    post_agency({commit},agence){
        return api.agency.post_agency(agence).then((response)=>{   
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    
    put_agency({commit},data){
        return api.agency.put_agency(data.id,data.agency).then((response)=>{
            console.log(response.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    show_agency({ commit }, id) {
        return api.agency.show_agency(id).then((response) => {
            return response.data.data;
        })
    },
    delete_agences({ commit }, id) {
        return api.agency.delete_agences(id).then((response) => {
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    },
    active_agences({ commit }, id) {
        return api.agency.active_agences(id).then((response) => {
            return response.data;
        })
        .catch(error => {
            return error.response.data
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
